import { ThemeConstants } from '../themes'

export enum ThemeTypes {
  SWITCH_THEME = 'SWITCH_THEME',
}

export interface SwitchTheme {
  theme: ThemeConstants
  type: ThemeTypes.SWITCH_THEME
}

export type ThemeAction = SwitchTheme
